import React, { useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useAxiosClient } from "../../hooks/useAxiosClient"
import { navigate } from "gatsby"
import { AuthContext } from "../../contexts/AuthContext"
import Notification from "./Notification"

const Notifications = props => {
  const { endpoint = "/alerts/intranet/", withModal } = props
  const { userInfo } = useContext(AuthContext)
  const [modalVisible, setModalVisible] = useState(true)

  const [{ data: notifications }, getData] = useAxiosClient(
    { url: endpoint },
    { manual: true }
  )
  const [, triggerRequest] = useAxiosClient(
    {},
    {
      manual: true,
    }
  )

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = ({ pk: notificationPK, link, viewed }) => {
    if (!viewed)
      triggerRequest({
        url: "/alert/views/",
        method: "POST",
        data: {
          alert: notificationPK,
          person: userInfo.pk,
        },
      }).then(() => {
        if (link.link_intranet_responsables) {
          navigate(link.link_intranet_responsables)
        } else {
          navigate("/")
          setModalVisible(false)
        }
      })
    else navigate(link.link_intranet_responsables)
  }

  const renderNotifications = () =>
    Array.isArray(notifications) &&
    notifications.map(notification => (
      <Notification
        {...notification}
        withModal={withModal}
        onClick={handleClick}
        modalVisible={modalVisible}
      />
    ))

  return <div className="Notifications">{renderNotifications()}</div>
}

Notifications.propTypes = {
  endpoint: PropTypes.string,
  withModal: PropTypes.bool,
}

export default Notifications
